import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isExporting: false,
	update: false
};

const dynamicListSlice = createSlice({
	name: 'dynamicListData',
	initialState,
	reducers: {
		setDynamicListData: (state, { payload }) => ({
			...state,
			update: false,
			[payload.id]: {
				...state[payload.id],
				update: false,
				...payload.data
			}
		}),
		updateDynamicListData: (state, { payload }) => {
			if (!payload) throw new Error('Payload is required for updateDynamicListData action');

			if (state[payload]) {
				return {
					...state,
					[payload]: {
						...state[payload],
						update: true
					}
				};
			} else {
				return state;
			}
		},
		setDynamicListExporting: (state, { payload }) => ({
			...state,
			isExporting: payload
		}),
		updateDynamicListsInPage: (state) => ({
			...state,
			update: true
		})
	}
});

export const { setDynamicListData, updateDynamicListData, setDynamicListExporting, updateDynamicListsInPage } =
	dynamicListSlice.actions;

export default dynamicListSlice.reducer;
